import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { from, Observable, switchMap, catchError } from 'rxjs';
import { throwError } from 'rxjs';
import { AuthServiceFactory } from './auth.service.factory';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private authServiceFactory: AuthServiceFactory) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Get the instance of AuthService
        const authService = this.authServiceFactory.createAuthService();

        // Ensure token is valid (proactively refresh if needed) before sending
        return from(authService.ensureValidAccessToken()).pipe(
            switchMap((authToken: string | null) => {
                let req = request;
                if (authToken) {
                    req = request.clone({ setHeaders: { Authorization: `Bearer ${authToken}` } });
                }

                return next.handle(req).pipe(
                    catchError((err: any) => {
                        // If unauthorized, attempt a single refresh and retry
                        if (err && err.status === 401) {
                            return from(authService.refreshToken()).pipe(
                                switchMap((ok: boolean) => {
                                    if (ok) {
                                        // retry original request with new token
                                        return from(authService.getAuthToken()).pipe(
                                            switchMap((newToken: string | null) => {
                                                const retryReq = newToken ? request.clone({ setHeaders: { Authorization: `Bearer ${newToken}` } }) : request;
                                                return next.handle(retryReq);
                                            })
                                        );
                                    }
                                    // Refresh returned false — do NOT call logout() here.
                                    // auth.service.ts refreshToken() already calls logout() when the
                                    // server explicitly rejects the refresh token (401/403). Any other
                                    // failure (network error, 500) is transient and should not end the
                                    // user's session.
                                    console.warn('[AuthInterceptor] token refresh returned false after 401 — propagating error without logout');
                                    return throwError(() => err);
                                })
                            );
                        }
                        return throwError(() => err);
                    })
                );
            })
        );
    }
}
